import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import WalletBalanceCard from "../../../Components/WalletBalanceCard";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SavingsIcon from "@mui/icons-material/Savings";
import PoolIcon from "@mui/icons-material/Pool";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PaidIcon from "@mui/icons-material/Paid";

const WalletBalances = ({ balances, loading }) => {
  const walletOrder = [
    "in_wallet",
    "actual_saving",
    "saving_wallet",
    "no_of_shares",
    "guarantorship_wallet",
    "pool_fund",
    "loan",
  ];

  const balanceConfig = {
    in_wallet: {
      title: "E-Wallet",
      icon: AccountBalanceWalletIcon,
      color: "primary",
    },
    actual_saving: {
      title: "Actual Savings",
      icon: SavingsIcon,
      color: "error",
    },
    saving_wallet: {
      title: "Available Savings",
      icon: SavingsIcon,
      color: "success",
    },
    loan: {
      title: "Loans",
      icon: PaidIcon,
      color: "info",
    },
    pool_fund: { title: "Pool Fund", icon: PoolIcon, color: "warning" },
    guarantorship_wallet: {
      title: "Guarantor Savings",
      icon: VerifiedUserIcon,
      color: "secondary",
    },
    // no_of_shares: {
    //   title: "Shares Value",
    //   icon: ShowChartIcon,
    //   color: "warning",
    // },
  };

  const normalizedBalances = (balances || []).map((wallet) => ({
    ...wallet,
    account_balance: wallet.account_balance ?? 0,
  }));

  const orderedBalances = normalizedBalances.sort(
    (a, b) => walletOrder.indexOf(a.type) - walletOrder.indexOf(b.type)
  );

  const formattedBalances = Object.keys(balanceConfig)
    .map((key) => {
      const found = balances.find((b) => b.type === key);
      return {
        type: key,
        account_balance: found ? found.account_balance : 0,
        ...balanceConfig[key],
      };
    })
    .sort((a, b) => a.order - b.order);

  console.log("formattedBalances", formattedBalances);

  // if (loading)
  //   return <CircularProgress sx={{ display: "block", mx: "auto", my: 4 }} />;
  if (!balances || balances.length === 0)
    return (
      <Typography color="text.secondary" sx={{ p: 3 }}>
        No wallet information available.
      </Typography>
    );

  const totalBalance = normalizedBalances.reduce(
    (sum, w) => sum + (w.account_balance || 0),
    0
  );

  return (
    <Box
      sx={{
        my: 2,
        // p: { xs: 2, md: 4 },
      }}
    >
      <Grid
        container
        spacing={2}
        display={"flex"}
        alignItems={"stretch"}
        // justifyContent={"center"}
      >
        {loading ? (
          <CircularProgress sx={{ display: "block", mx: "auto", my: 4 }} />
        ) : (
          formattedBalances.map((wallet, index) => {
            const config = balanceConfig[wallet.type];
            if (!config) return null;
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
                key={index}
                sx={{ mb: 2 }}
              >
                <WalletBalanceCard
                  title={config.title}
                  balance={wallet.account_balance}
                  icon={config.icon}
                  color={config.color}
                />
              </Grid>
            );
          })
        )}
      </Grid>
      {/* </CardContent> */}
    </Box>
  );
};

export default WalletBalances;
